module.exports = __webpack_public_path__ + "static/img/sm_js_5.b083773.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sm/sm_js_5.png
// module id = /uGh
// module chunks = 1